<template>
  <pt-report-unscramble-apply-table class="pt-report-unscramble-apply-table__withData"  ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels">
    <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-report-unscramble-apply-table>
</template>

<script>
import PtReportUnscrambleApplyTable from './index'
export default {
  name: 'pt-report-unscramble-apply-table__withData',
  components: {
    'pt-report-unscramble-apply-table': PtReportUnscrambleApplyTable
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: []
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getDataList (page, next) {
      let data = {
        example: { status: this.status },
        pageable: { page: page, size: this.pageSize, sort: ['createdDate,asc'] }
      }
      // this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('orderHandleList', data).then(res => {
        next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    }
  }
}
</script>
